import PropTypes from 'prop-types';
import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../../organisms/Layout/Layout';
import BubbleCtaSection from '../../organisms/BubbleCtaSection/BubbleCtaSection';
import { renderPageSections } from '../renderPageSections';

const Page = ({ data, location: { href } }) => {
  // unpublished pages return null data
  if (!data || data.sanityPage === null) {
    return null;
  }

  const pageProps = {
    id: data.sanityPage._id,
    metadata: { ...data.sanityPage._rawRoute, href },
    header: data.sanityPage._rawHeader,
    sections: data.sanityPage._rawSections,
    bubbleCtaSection: data.sanityPage._rawBubbleCtaSection,
  };

  return (
    <Layout
      sanityId={pageProps.id}
      {...pageProps.header}
      {...pageProps.metadata}
    >
      {renderPageSections(pageProps.sections)}
      {pageProps.bubbleCtaSection && (
        <BubbleCtaSection {...pageProps.bubbleCtaSection} />
      )}
    </Layout>
  );
};

Page.propTypes = {
  data: PropTypes.shape({ sanityPage: {} }),
  location: PropTypes.shape({ href: PropTypes.string }),
};

Page.defaultProps = {
  data: {},
  location: { href: '' },
};

export default Page;

export const query = graphql`
  query($slug: String) {
    sanityPage(
      route: { enabled: { eq: true }, slug: { current: { eq: $slug } } }
    ) {
      _rawRoute(resolveReferences: { maxDepth: 100 })
      _rawHeader(resolveReferences: { maxDepth: 100 })
      _rawSections(resolveReferences: { maxDepth: 100 })
      _rawBubbleCtaSection(resolveReferences: { maxDepth: 100 })
      _id
    }
  }
`;
